<template>
  <button v-if="auth && !isAuthPage" style="z-index: 8888;" class="md:hidden fixed left-4 top-6 p-2 rounded-lg bg-white shadow-md text-[#0d47a1]" @click="toggleMenu">
    <i class="material-icons text-2xl">{{ isOpen ? 'close' : 'menu' }}</i>
  </button>
  
  <div :class="auth?'md:flex-rows':'md:grid-cols-1'" class="md:flex bg-[#faf8ff] h-screen overflow-hidden">
    <!-- Desktop Sidebar -->
    <div v-if="auth && !isAuthPage" @mouseenter="thestyle='width: 20em'" @mouseleave="thestyle='width: 6.5em'" class="transition-all duration-300">
      <SideBar :thestyle="thestyle" class="h-screen hidden md:block" />
    </div>

    <!-- Mobile Sidebar Overlay -->
    <div v-if="auth && !isAuthPage && isOpen" class="fixed inset-0 z-[9999] md:hidden">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-gray-900/50 backdrop-blur-sm" @click="toggleMenu()"></div>
      
      <!-- Sidebar Content -->
      <div class="absolute inset-y-0 left-0 w-3/4 max-w-sm bg-white shadow-2xl animate__animated animate__slideInLeft animate__faster">
        <SideBar thestyle="width: 100%" @click.stop="" />
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="w-full h-full overflow-y-auto custom-scrollbar flex flex-col">
      <NavBar v-if="auth && !isAuthPage" />
      <main class="flex-1">
        <router-view />
      </main>
      <FooterComponent v-if="auth && !isAuthPage"/>  
    </div>
    <OTPVerificationModal :show="showOTP" @verified="onVerified" />
  </div>
</template>

<script>

import FooterComponent from './components/Footer.vue'
import NavBar from './components/NavBar.vue'
import SideBar from './components/SideBarMenu.vue'
import OTPVerificationModal from './components/OTPVerificationModal.vue'
import get_api from "./service/api.js"
import base_url from "./service/base_url.js"


export default {
  name: 'App',
  created(){
    this.api = get_api(this.$router)
    const token = localStorage.getItem("XPAYROLLaccess_token")
    if (token && token !== "undefined" && token !== "null" && token.trim() !== ""){
      this.api.get(base_url+"/me").then((resp)=>{
        // Enable auth for any valid user (admin or employee)
        this.auth = true
        const user = resp.data.data
        if (user && user.is_verified === false) {
          this.showOTP = true
        }
      }).catch(() => {
        this.auth = false
        const currentToken = localStorage.getItem("XPAYROLLaccess_token")
        if (currentToken === token) {
          localStorage.removeItem("XPAYROLLaccess_token")
        }
      })
    }
  },
  components: {
    FooterComponent,
    NavBar,
    SideBar,
    OTPVerificationModal
  },
  computed: {
    isAuthPage() {
      // Hide global nav/footer on login and registration pages
      return this.$route.path === '/' || this.$route.path === '/register';
    }
  },
  data(){
    return {
      thestyle: 'width: 6.5em',
      isOpen: false,
      auth: false,
      showOTP: false
    }
  },
  methods: {
    toggleMenu(){
       this.isOpen = !this.isOpen
      },
    onVerified() {
      this.showOTP = false
      // Optionally reload or just continue
    }
  }
}
</script>

<style scoped>
@font-face {
    font-family: bigdeal;
    src: url("@/assets/fonts/aBigDeal.ttf");
}

/* @font-face {
    font-family: kai;
    src: url("@/assets/fonts/kai.ttf");
}

* {
    font-family: kai;
  } */

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
}

/* nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
